module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.ttf?370dd5af19f8364907b6e2c41f45dbbf";